<template>
  <v-col>
    <!-- Purchase data table -->
    <sales-table
      :key="index"
      url-api="/order?filter=purchasing"
      :headers="headers"
    >
      <!-- Buy  -->
      <template v-slot:urlCreate="">
        <v-btn
          class="primary"
          @click.prevent="
            $router.push({
              name: 'BuyBySuppilier',
            })
          "
        >
          <v-icon>mdi-plus</v-icon>
          Add Purchase
        </v-btn>
      </template>
      <!-- end -->
      <!-- Buy transaction -->
      <template v-slot:refrence="{ item }">
        <div class="white pa-1">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-img
                v-bind="attrs"
                :src="item.barcode"
                lazy-src="/storage/default_img/no_image.png"
                aspect-ratio="1"
                max-width="100"
                max-height="15"
                v-on="on"
              />
            </template>
            <span>TRX #{{ item.key }}</span>
          </v-tooltip>
        </div>
      </template>
      <!-- end -->

      <!-- Purchase Method -->
      <template v-slot:method="{ item }">
        {{ item.method ? "Live" : "Due" }}
      </template>
      <!-- end -->

      <!-- Purchase QTY -->
      <template v-slot:qty="{ item }">
        {{ item.totalItems }}
      </template>
      <!-- end -->

      <!-- Purchase subtotal -->
      <template v-slot:subTotal="{ item }">
        {{ item.subTotal | currency }}
      </template>
      <!-- end -->

      <!-- Discount info-->
      <template v-slot:discountRate="{ item }">
        {{ item.discountRate }}%,
        {{ item.discountedAmount | currency }}
      </template>
      <!-- end -->

      <!--Purchase Tax -->
      <template v-slot:taxRate="{ item }">
        {{ item.taxRate }}%,
        {{ item.taxAmount | currency }}
      </template>
      <!-- end -->

      <!-- Total amount -->
      <template v-slot:totalAmount="{ item }">
        {{ item.totalAmount | currency }}
      </template>
      <!-- end -->

      <!-- ColumnActions -->
      <template v-slot:columnaction="{ item }">
        <!-- Sale details -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'PurchaseTransactionDetails',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-more
              </v-icon>
            </v-btn>
          </template>
          <span>More details</span>
        </v-tooltip>
        <!-- end -->

        <!-- Print purchase invoice -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'PrintPurchase',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-printer
              </v-icon>
            </v-btn>
          </template>
          <span>Print</span>
        </v-tooltip>
        <!-- end -->

        <!-- Purchase remove -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              icon
              @click="warningPurchaseRemove(item)"
              v-on="on"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
        <!-- end -->
      </template>
      <!-- end columnActions -->
    </sales-table>

    <!-- end data table -->

    <!-- Purchase remove confirmation dialog  -->
    <v-dialog
      v-model="purchaseRemoveWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Warning
        </v-card-title>
        <v-card-text>
          Are you sure to remove ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="purchaseRemoveWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removePurchase"
          >
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-col>
</template>

<script>
import SalesTable from "../common/DataTable.vue";
import { mapActions } from "vuex";

export default {
  components: {
    "sales-table": SalesTable,
  },
  data() {
    return {
      purchaseRemoveWarning: false,
      sale: [],
      index: 1,
      headers: [
        {
          text: "Created At",
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Reference",
          sortable: true,
          value: "refrence",
          slot: "refrence",
        },
        {
          text: "Quantity",
          sortable: false,
          value: "totalItems",
          slot: "qty",
        },

        {
          text: "Method",
          sortable: false,
          value: "method",
          slot: "method",
        },
        {
          text: "Net Cost",
          sortable: true,
          value: "subTotal",
          slot: "subTotal",
        },
        {
          text: "Discount",
          sortable: false,
          value: "discountRate",
          slot: "discountRate",
        },
        {
          text: "Tax",
          sortable: false,
          value: "taxRate",
          slot: "taxRate",
        },

        {
          text: "Total Amount",
          sortable: false,
          value: "totalAmount",
          slot: "totalAmount",
        },

        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),

    removePurchase() {
      window.axios.delete("/order/" + this.$data.sale.id).then((response) => {
        this.$data.purchaseRemoveWarning = false;
        this.$data.index++;
        this.feedback(response.data.message);
      });
    },

    warningPurchaseRemove(sale) {
      this.$data.sale = sale;
      this.$data.purchaseRemoveWarning = true;
    },
  },
};
</script>
